import React, { useEffect, useState } from "react";
import SectionTitle from "../../components/SectionTitle";
import { SERVER_URL } from "../../api/url";
import axios from "axios";

const Event = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/event?isDone=true`);
      const fetchedData = response.data?.data || response.data || [];
      setBlogs(fetchedData);
    } catch (err) {
      console.error("Error fetching events:", err.response || err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="instructors___page pt---120 pb---140">
      <div className="container">
        <SectionTitle Title="Explore Our Events & Programs" />

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="row mt-4">
            {blogs.length === 0 ? (
              <div className="course-message">
                <p className="no-courses">There are no event now.</p>
              </div>
            ) : (
              blogs.map((data, index) => (
                <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div 
                    className="instructor__content card shadow-sm border-0 overflow-hidden position-relative"
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="instructor__image overflow-hidden position-relative">
                      <img
                        crossOrigin="anonymous"
                        className="blog-card-img img-fluid w-100"
                        style={{ height: '200px', objectFit: 'cover' }}
                        src={`https://back.yourfrenchteachers.com/${data?.coverDesktop}`}
                        alt={data?.name}
                        onError={(e) => { e.target.src = 'https://via.placeholder.com/400x250?text=No+Image'; }}
                      />
                      
                      {/* Smooth Under to Upper Overlay */}
                      <div 
                        className="content__hover d-flex align-items-center justify-content-center"
                        style={{
                          position: 'absolute',
                          top: 0, left: 0, width: '100%', height: '100%',
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          opacity: 0,
                          transition: 'opacity 0.4s ease-in-out',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.opacity = 1;
                          const btn = e.currentTarget.querySelector('.animated-arrow-btn');
                          if (btn) btn.style.transform = 'translateY(0)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.opacity = 0;
                          const btn = e.currentTarget.querySelector('.animated-arrow-btn');
                          if (btn) btn.style.transform = 'translateY(30px)';
                        }}
                      >
                        <a href={data?.name} target="_blank"
                          className="animated-arrow-btn"
                          style={{
                            background: 'transparent',
                            border: '1px solid white',
                            color: 'white',
                            padding: '5px 15px',
                            borderRadius: '50px',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                            transform: 'translateY(30px)',
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.background = 'white';
                            e.currentTarget.style.color = 'black';
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.background = 'transparent';
                            e.currentTarget.style.color = 'white';
                          }}
                        >
                          View Details
                          <i className="fas fa-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Event;